import { Component, OnInit, OnDestroy, Input, OnChanges, HostListener, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EMPTY, Subscription } from 'rxjs';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { BroadcastingInfo } from 'src/app/models/broadcastings-models/broadcasting-info.model';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-broadcastings-broadcasting-info-card',
  templateUrl: './broadcastings-broadcasting-info-card.component.html',
  styleUrls: ['./broadcastings-broadcasting-info-card.component.scss']
})
export class BroadcastingsBroadcastingInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() broadcasting: BroadcastingInfo;
  centerList;
  editingLocked;
  updateBroadcastingInfoSubscription: Subscription;
  basicDataForm = new FormGroup({
    active: new FormControl({value: null, disabled: true}),
    name: new FormControl({ value: null, disabled: true}, Validators.required),
    showApp: new FormControl({ value: false, disabled: true})
  });

  constructor(private userStorageService: UserStorageService,
              private broadcastingsService: BroadcastingsService,
              private snackbarService: SnackBarService,
              private eRef: ElementRef) {
                this.editingLocked = true;
              }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
  }

  ngOnChanges() {
    if (this.broadcasting) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.target.className !== 'mat-option-text') {
        if (this.broadcasting && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
        this.lockEdition();
      }
    }
  }

  public submitForm() {
    const validation = this.validateForm();
    if (validation) {
      this.updateBroadcastingInfoSubscription = this.broadcastingsService.updateBroadcastingInfo(this.broadcasting.BroadcastingInternalId, this.basicDataForm.get('active').value, this.basicDataForm.get('name').value, this.basicDataForm.get('showApp').value).pipe(
        tap(o => this.editingLocked = true),
        tap(o => this.snackbarService.open('broadcastings-page.snackbar messages.update broadcasting success', 'success')),
        tap(o => this.broadcastingsService.refreshBroadcasting()),
        catchError(error => {
          this.snackbarService.open(error['error']['message'], 'error');
          this.broadcastingsService.refreshBroadcasting();
          return EMPTY;
        })
      ).subscribe();
    } else {
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('name').valid) {
      return 'broadcastings-page.snackbar messages.name broadcasting error';
    } else {
      return true;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      active: this.broadcasting.Active,
      name: this.broadcasting.BroadcastingName,
      showApp: this.broadcasting.ShowApp
    });
  }

  public unlockEdition() {
    this.basicDataForm.get('active').enable();
    this.basicDataForm.get('name').enable();
    this.basicDataForm.get('showApp').enable();
    this.editingLocked = false;
  }

  public lockEdition() {
    this.basicDataForm.get('active').disable();
    this.basicDataForm.get('name').disable();
    this.basicDataForm.get('showApp').disable();
    this.editingLocked = true;
  }

  ngOnDestroy() {
    if (this.updateBroadcastingInfoSubscription) { this.updateBroadcastingInfoSubscription.unsubscribe(); }
  }

}
